// src/packages/chubb/pa/chubb_pa_series_e_2025/ChubbPASeriesECard.jsx
import React from "react";
import "./chubb_pa_series_e.css";

export default function ChubbPASeriesECard({ onSelect }) {
  return (
    <div className="pkg-card chubb-pa-e">
      <div className="pkg-body">
        <h3>Chubb PA Series E (แผน 1–8 + Kid)</h3>
        <p>อุบัติเหตุส่วนบุคคล • ค่ารักษา • วันหยุดสาธารณะ • มอเตอร์ไซค์</p>
        <ul className="pkg-list">
          <li>ทุนชีวิต/ทุพพลภาพ สูงสุดหลายล้านบาท (ตามแผน)</li>
          <li>ค่ารักษาพยาบาลต่อครั้ง + สิทธิพิเศษอื่น ๆ</li>
          <li>ทำได้ทั้งเดี่ยว / คู่สมรส / ครอบครัว</li>
        </ul>
        <button className="pkg-btn" onClick={onSelect}>ดูรายละเอียด</button>
      </div>
    </div>
  );
}
